module.exports = __webpack_public_path__ + "img/logo_circle.f92375bc.png";